import { EXTRACT_OCR_STATUS } from "core/consts";
import { VoiceTranscriptFile } from "core/types";
import { Modal, ModalBody, ModalContent, ModalHeader } from "ds/ui";
import { VoiceTranscriptViewer } from "dsl/ecosystems/RecareDocs/Modal/Sources/VoiceTranscriptViewer";

/**
 * Read-only "see details" view for a voice transcript row in the files
 * table, rendered by `FileDetailsModal` in place of the PDF/DOCX viewer.
 * Reuses the same viewer as the RecareDocs source panel (PR DEV-20265).
 */
export function VoiceTranscriptPreviewModal({
  file,
  onClose,
}: {
  file: VoiceTranscriptFile;
  onClose: () => void;
}) {
  return (
    <Modal isOpen onClose={onClose}>
      <ModalContent className="flex h-[90vh] w-[95vw] max-w-[800px] flex-col">
        <ModalHeader className="p-4">
          <h1 className="pr-6 text-heading-lg font-bold wrap-break-word">
            {file.filename}
          </h1>
        </ModalHeader>
        <hr className="w-full border-gray-400" />
        <ModalBody className="flex h-full flex-1 flex-col overflow-hidden p-0">
          <VoiceTranscriptViewer
            isDeleted={file.status === EXTRACT_OCR_STATUS.DELETED}
            url={file.processed_document_uri ?? ""}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
